import { useEffect, useState } from "react";

import ModalTitle from "../../../../../../../components/HexModal/ModalTitle";

import { getLabel } from "../../../../../../../hooks/use-labels";

import HexReactDatePicker from "../../../../../../../components/FormFactory/HexReactDatePicker";

import RadioListing from "../../../../../../../components/RadioListing";

import TimelineFooter from "./TimelineFooter";

import {
  MAX_DELIVERY_DATE,
  MIN_DELIVERY_DATE,
} from "../../../../../../../utils/constants";

import "./style.css";
import { filterTimeLines, getExcludeDates, getSlot } from "./timeline-utils";
import HexLoader from "../../../../../../../components/HexLoader";

const DeliveryTimeline = ({
  timeSlots,
  onSaveType,
  onBack,
  selectedTimeSlot,
}) => {
  const [loading, setLoading] = useState(true);

  const [date, setDate] = useState(
    selectedTimeSlot ? new Date(selectedTimeSlot.date) : new Date()
  );

  const [timelineOptions, setTimelineOptions] = useState([]);

  const [selectedTime, setSelectedTime] = useState(
    selectedTimeSlot ? selectedTimeSlot.id : ""
  );

  useEffect(() => {
    const slots = filterTimeLines(timeSlots, date);
    setTimelineOptions(slots);

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const onChange = (date) => {
    setDate(date);
  };

  const onSelectTime = ({ target }) => {
    setSelectedTime(target.value);
  };

  const onSave = () => {
    const timeSlot = getSlot(timelineOptions, selectedTime);
    onSaveType(timeSlot);
  };

  return (
    <div className="delivery-types-timeline relative">
      <div className="delivery-date-container">
        <ModalTitle
          text={getLabel("deliveryDateLabel")}
          bordered={true}
          className={"mb-20"}
        />

        <HexReactDatePicker
          value={date}
          onChange={onChange}
          minDate={MIN_DELIVERY_DATE || null}
          maxDate={MAX_DELIVERY_DATE || null}
          excludeDates={getExcludeDates(timeSlots)}
        />
      </div>

      <div className="delivery-time-container">
        <ModalTitle text={getLabel("deliveryTimeLabel")} bordered={true} />

        <div className="timeline-list">
          {loading ? (
            <HexLoader />
          ) : (
            <RadioListing
              options={timelineOptions}
              onChange={onSelectTime}
              value={selectedTime}
              className="timeline-listing"
              labelClass={"font-14-normal-500-lh-18"}
            />
          )}
        </div>
      </div>

      <TimelineFooter onSave={onSave} onBack={onBack} disable={!selectedTime} />
    </div>
  );
};

export default DeliveryTimeline;
